import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileContract, faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const { Title, Text } = Typography

const TermsConditionsModal = ({ visible, onClose, initialValue = '', onSave, token, basicInfoForm }) => {
  const [content, setContent] = useState('')
  const [loading, setSaving] = useState(false)

  useEffect(() => {
    setContent(initialValue)
  }, [initialValue, visible])

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'video'],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ['code-block'],
      ['clean']
    ]
  }

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
    'align',
    'color',
    'background',
    'code-block'
  ]

  const handleCancel = () => {
    setContent(initialValue)
    onClose()
  }

  const handleSave = async () => {
    onSave(content)
    onClose()
  }

  return (
    <Modal
      title={
        <Space size={12}>
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              backgroundColor: `${token?.colorPrimary}20`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FontAwesomeIcon icon={faFileContract} style={{ color: token?.colorPrimary, fontSize: '18px' }} />
          </div>
          <div>
            <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
              Terms & Conditions Editor
            </Title>
            <Text type='secondary' style={{ fontSize: '14px' }}>
              Create and edit your facility's terms and conditions
            </Text>
          </div>
        </Space>
      }
      open={visible}
      onCancel={handleCancel}
      width={1000}
      style={{ top: 20 }}
      bodyStyle={{
        padding: '24px',
        maxHeight: '70vh',
        overflow: 'auto'
      }}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Space>
            <Button icon={<FontAwesomeIcon icon={faTimes} />} onClick={handleCancel} size='large'>
              Cancel
            </Button>
            <Button
              type='primary'
              icon={<FontAwesomeIcon icon={faSave} />}
              onClick={handleSave}
              loading={loading}
              size='large'
            >
              Save Terms & Conditions
            </Button>
          </Space>
        </div>
      }
    >
      <div style={{ marginBottom: '16px' }}>
        <Text type='secondary'>
          Use the rich text editor below to create comprehensive terms and conditions for your facility. You can format
          text, add lists, links, and other content as needed.
        </Text>
      </div>

      <div
        style={{
          border: `1px solid ${token?.colorBorder}`,
          borderRadius: '8px',
          overflow: 'hidden'
        }}
      >
        <ReactQuill
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          style={{
            minHeight: '400px',
            fontSize: '14px'
          }}
          theme='snow'
          placeholder="Enter your facility's terms and conditions here..."
        />
      </div>

      <div
        style={{
          marginTop: '16px',
          padding: '12px',
          backgroundColor: `${token?.colorInfo}10`,
          borderRadius: '6px',
          border: `1px solid ${token?.colorInfo}30`
        }}
      >
        <Text type='secondary' style={{ fontSize: '12px' }}>
          <strong>Tip:</strong> Include important information such as appointment policies, payment terms, cancellation
          policies, privacy practices, and any other legal requirements for your facility.
        </Text>
      </div>
    </Modal>
  )
}

export default TermsConditionsModal
